import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

//import Therapy from './screens/index.vue';
const Therapy = () => import('./screens/index.vue')

const therapyRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.THERAPY_VIEW,
    PERMISSIONS_KEYS.THERAPY_INSERT,
    PERMISSIONS_KEYS.THERAPY_EDIT,
  ])
) {
  therapyRoutes.push({
    path: '/terapia',
    name: 'Cadastro / Consulta|Terapia',
    component: Therapy,
    meta: {
      icon: 'fa-sliders-h',
      requiresAuth: true,
    },
  });
}

export { therapyRoutes };

